"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersTab = void 0;
const router_1 = require("client/components/router");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const edit_orders_1 = require("../../components/edit-orders");
const store_1 = require("../../store");
require("./orders.less");
let OrdersTab = class OrdersTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.onCancelEditSite = () => {
            router_1.RouteManager.transitionTo("/pharmacies");
        };
        this.componentDidMount = async () => {
            const siteId = Number(this.props.params[0]);
            if (siteId && !store_1.sitesDetailStore.site.value) {
                await store_1.sitesDetailStore.readSite(siteId);
            }
        };
    }
    render() {
        const siteId = Number(this.props.params[0]);
        return (React.createElement("div", { className: "orders__form orderForm-section" },
            React.createElement(edit_orders_1.EditOrders, { error: store_1.sitesDetailStore.site.error, loading: store_1.sitesDetailStore.site.loading, onCancel: this.onCancelEditSite, site: siteId ? store_1.sitesDetailStore.site.value : null })));
    }
};
OrdersTab = __decorate([
    mobx_react_1.observer
], OrdersTab);
exports.OrdersTab = OrdersTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/tabs/orders/orders.tsx
// module id = 4038
// module chunks = 0